;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import { uniqueGroups } from "./filters"
import type {
  GeographicGroupConnection,
  GeographicGroupPage,
  GeographicLandingVariables,
  GeographicListingScope,
  LandingPageDocument,
  PublicLandingGroup,
} from "./types"

export const GEOGRAPHIC_GROUP_PAGE_SIZE = 12

export function isGeographicListingScope(
  value: unknown,
): value is GeographicListingScope {
  return value === "local" || value === "online"
}

export function buildGeographicLandingVariables(
  page: LandingPageDocument,
  scope: GeographicListingScope,
): GeographicLandingVariables {
  const state = page.data.state?.trim().toUpperCase()
  if (!page.data.geographic_search || !state || !/^[A-Z]{2}$/.test(state)) {
    throw new Error("Geographic landing page configuration is incomplete")
  }

  const variables: GeographicLandingVariables = {
    iState: state,
    iScope: scope,
    first: GEOGRAPHIC_GROUP_PAGE_SIZE,
  }

  // A missing region/city list must never widen the local section to the state.
  // Online eligibility depends only on the participant's state, not locality.
  if (
    scope === "local" &&
    (page.data.local_cities != null || page.data.location_kind !== "state")
  ) {
    const cities = new Map<string, string>()
    for (const value of page.data.local_cities || []) {
      const city = typeof value === "string" ? value.trim().replace(/\s+/g, " ") : ""
      if (city && !cities.has(city.toLowerCase()))
        cities.set(city.toLowerCase(), city)
    }
    variables.iCities = [...cities.values()]
  }

  return variables
}

export function readGeographicGroupPage(
  connection: GeographicGroupConnection | null | undefined,
): GeographicGroupPage {
  if (
    !connection ||
    !Array.isArray(connection.edges) ||
    !Number.isInteger(connection.totalCount) ||
    connection.totalCount < 0 ||
    typeof connection.pageInfo?.hasNextPage !== "boolean" ||
    (connection.pageInfo.hasNextPage && !connection.pageInfo.endCursor)
  ) {
    throw new Error("Geographic group results are unavailable")
  }

  const groups = connection.edges
    .map((edge) => edge?.node)
    .filter((group): group is PublicLandingGroup => Boolean(group))

  return {
    groups: uniqueGroups(groups),
    totalCount: connection.totalCount,
    endCursor: connection.pageInfo.endCursor || null,
    hasNextPage: connection.pageInfo.hasNextPage,
  }
}
